import { createFileRoute, redirect } from '@tanstack/react-router'
import { orderContractDocumentSearchSchema, OrderContractWorkspace } from '@/features/order/index.ts'

export const Route = createFileRoute('/_authenticated/orders/service/contract/$orderId')({
  beforeLoad: ({ params }) => {
    if (!Number.isSafeInteger(Number(params.orderId)) || Number(params.orderId) < 1) {
      throw redirect({ to: '/orders/service', search: { current: 1, pageSize: 20 } })
    }
  },
  validateSearch: orderContractDocumentSearchSchema,
  component: Page
})
function Page() {
  const { orderId } = Route.useParams()
  const { currentSession } = Route.useRouteContext()
  return (
    <OrderContractWorkspace
      ids={[Number(orderId)]}
      orderType="service"
      documentId={Route.useSearch().documentId}
      canEdit={
        currentSession.isSuperAdmin ||
        currentSession.permissions.some((permission) =>
          ['contract.document.create', 'contract.document.confirm'].includes(permission)
        )
      }
    />
  )
}
